import apiFn from 'common/services/api-service';

const api = () => apiFn('/api/cms/v1/staff-details');

export const listStaff = () =>
  api()
    .get('')
    .then(response => response.data);

export const createStaff = async payload =>
  api()
    .post('', {
      ...payload,
      // Make this new staff a member of the "EventMobi Staff" group defined in the database
      staffGroupIds: ['5BFBCFB9062C4440BF7C131BE882ED82'],
    })
    .then(response => response.data);

const deleteStaff = async staffId =>
  api()
    .delete(staffId)
    .then(response => response.data);

export const deleteMultipleStaff = async staffIds => {
  const promises = staffIds.map(id => deleteStaff(id));
  return Promise.all(promises);
};
